<template>
  <div
    id="samyan-coop-content"
    class="samyan-coop-content"
  >
    <global-header />
    <nuxt />
    <global-footer />

    <!-- POPUP -->
    <b-modal
      id="popup-banner-modal"
      ref="popup-banner-modal"
      centered
      size="xl"
      hide-header
      modal-class="coop-modal popup-banner"
      hide-footer
    >
      <button
        type="button"
        class="modal-close-button"
        @click.prevent="closeModal"
      >
        <img src="~assets/images/close-button.svg">
      </button>
      <div>
        <img
          class="popup-banner-img"
          :src="popupList.image_url"
        >
      </div>
    </b-modal>
    <!-- /POPUP -->

    <!-- Matomo -->
    <script type="text/javascript">
      var _paq = window._paq || [];
      /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
      (function() {
      var u="//samyancoop.samyan-mitrtown.com/analytics/";
      _paq.push(['setTrackerUrl', u+'matomo.php']);
      _paq.push(['setSiteId', '1']);
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.type='text/javascript'; g.async=true; g.defer=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
      })();
    </script>
    <!-- End Matomo Code -->
  </div>
</template>

<script>
import GlobalHeader from '~/components/Header.vue'
import GlobalFooter from '~/components/Footer.vue'

export default {
  name: 'DefaultLayout',
  components: {
    GlobalHeader,
    GlobalFooter
  },
  data () {
    return {
      currentPopupContent: null
    }
  },
  computed: {
    currentPageID () {
      return this.$store.getters['app/currentPageID']
    },
    popupList () {
      return this.$store.getters['content/popupList']
    }
  },
  watch: {
    currentPageID: {
      handler (val, oldVal) {
        if (val !== oldVal) {
          console.log('currentPageID', val, oldVal)
          if (this.$refs['popup-banner-modal']) {
            this.$refs['popup-banner-modal'].hide()
          }
          if (val === 'HOME') {
            this.$store.dispatch('content/GET_POPUP_BANNER_LIST')
              .then(() => {
                // check poup
                console.log('popupList', this.popupList)
                if (this.popupList.status === 'active' && this.popupList.image_url) {
                  if (this.$refs['popup-banner-modal']) {
                    this.$refs['popup-banner-modal'].show()
                  }
                }
              })
          }
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.$store.dispatch('app/SET_IS_MIGRATED', true)
    // pre-load university list
    this.$store.dispatch('app/GET_EDUCATION_INSTITUTES')
  },
  methods: {
    closeModal () {
      if (this.$refs['popup-banner-modal']) {
        this.$refs['popup-banner-modal'].hide()
      }
    }
  }
}
</script>

<style></style>
